<template>
  <div :id="$store.getters.appID" class="vue-video-playlist">
    <div v-if="playlist">
      <div class="grid-x">
        <div class="cell small-12 medium-12 large-7">
          <player></player>
        </div>
        <div v-if="playerReady" class="cell small-12 medium-12 large-5">
          <transition name="fade" :duration="1000">
            <playlist></playlist>
          </transition>
        </div>
      </div>
    </div>
    <div v-else class="grid-x">
      <div v-if="req_pwd" class="cell small-12 medium-4 large-4">
        <form @submit.prevent="getPlaylist">
          <div class="input-group">
            <input v-model="pwd" class="input-group-field" type="password" />
            <div class="input-group-button">
              <button type="submit" class="button dark-gray">Go</button>
            </div>
          </div>
        </form>
      </div>
      <div class="cell small-12 medium-4 large-4">
        <div v-if="$store.getters.loading" style="padding: .5rem 2rem;">
          Loading...
        </div>
        <div v-if="error" style="padding: .5rem 2rem;">
          {{error}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Player from './components/Player.vue'
import Playlist from './components/Playlist.vue'

export default {
  name: 'App',
  components: {
    Player, Playlist
  },
  props: ['id', 'r'],
  data () {
    return {
      error: false,
      req_pwd: false,
      pwd: ''
    }
  },
  methods: {
    init () {
      this.$store.commit('appID', (Math.random() + 1).toString(36).substring(7))
      if (this.r == 1) {
        this.req_pwd = true
      } else {
        this.getPlaylist()
      }
    },
    getPlaylist () {
      let vm = this
      vm.error = false
      vm.$store.commit('loading', true)
      this.axios({
        method: 'post',
        url: vm.$store.getters.url + '/' + vm.id,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'content-type': 'application/x-www-form-urlencoded'
        },
        data: {p: vm.pwd},
        responseType: 'json'
      })
      .then(function(response) {
        if (response.data.success) {
          vm.$store.commit('playlist', response.data.playlist)
        } else {
          if (response.data.error == 'BAD_PWD') {
            vm.error = 'The password was incorrect.'
          }
          console.log(response.data)
        }
        vm.$store.commit('loading', false)
      }.bind(this))
      .catch(function (error) {
        console.log(error)
      })
    }
  },
  computed: {
    playlist () {
      return this.$store.getters.playlist
    },
    playerReady () {
      return this.$store.getters.player.ready
    }
  },
  mounted () {
    this.init()
  }
}
</script>
